export default {"src":"/_next/static/media/cxVline.471a3dfe.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};